/**
 * The rejected-dates log — the main debugging surface of stage 1, so it is a readable
 * list with reasons in words, never raw JSON in a corner (визуальный контракт).
 * Acquisitions the pipeline could not date are shown too: a date that vanished without
 * a row is exactly the bug the audit table exists to catch.
 */

import { T } from "../strings";
import { formatDate, percent } from "../lib/format";
import type { StripModel } from "../lib/strip";

export function RejectedLog({ model }: { model: StripModel }) {
  const rejected = [...model.columns.filter((column) => !column.accepted), ...model.undated];

  return (
    <details
      className="k-details k-section k-section--tight"
      data-testid="rejected-log"
      open={rejected.length > 0}
    >
      <summary>
        {T.rejected.title}
        {rejected.length > 0 ? ` — ${T.rejected.count(rejected.length)}` : ""}
      </summary>

      {rejected.length === 0 ? (
        <p className="k-caption">{T.rejected.none}</p>
      ) : (
        <div className="k-log k-scroll">
          {rejected.map((column) => (
            <div className="k-logrow" key={column.key}>
              <span className="k-logrow__date">
                {column.date ? formatDate(column.date) : T.common.noData}
              </span>
              <span>
                <span className="k-logrow__reason">{column.reasonText}</span>
                <br />
                <span className="k-logrow__numbers">
                  {column.acquisitionId} · {T.strip.bad} {percent(column.badFraction)} ·{" "}
                  {T.strip.valid} {percent(column.validFraction)} · {T.strip.snow}{" "}
                  {percent(column.snowFraction)}
                </span>
              </span>
            </div>
          ))}
        </div>
      )}
    </details>
  );
}
